import { binarySearchByIndex0 } from 'utils';
export function visual_downsample(data, [min_x, max_x], pnt_count) {
    const left = binarySearchByIndex0(data, min_x).r;
    const right = binarySearchByIndex0(data, max_x).r;
    data = data.slice(Math.max(left - 1, 0), right + 1);
    const data_length = data.length;
    if (data_length <= pnt_count)
        return data;
    const x_per_bucket = (max_x - min_x) / pnt_count;
    let bucket_l = min_x;
    bucket_l -= bucket_l % x_per_bucket;
    const output = [data[0]];
    let i = 0;
    while (true) {
        const bucket_r = bucket_l + x_per_bucket;
        let max = null;
        let min = null;
        let first = null;
        let last = null;
        let first_null = false;
        let last_null = false;
        while (data[i] != null && i < data_length && data[i][0] < bucket_r) {
            const item = data[i];
            if (max == null || max[1] == null || (item[1] != null && item[1] > max[1]))
                max = item;
            if (min == null || min[1] == null || (item[1] != null && item[1] < min[1]))
                min = item;
            if (first == null) {
                if (item[1] == null)
                    first_null = true;
                first = item;
            }
            last_null = item[1] == null;
            last = item;
            i++;
        }
        if (first_null)
            output.push([bucket_l, null]);
        else if (first != null)
            output.push(first);
        if (min != null && max != null) {
            if (min[0] < max[0]) {
                if (min[0] !== first?.[0])
                    output.push(min);
                if (max[0] !== last?.[0])
                    output.push(max);
            }
            else {
                if (max[0] !== first?.[0])
                    output.push(max);
                if (min[0] !== last?.[0])
                    output.push(min);
            }
        }
        if (last_null)
            output.push([bucket_r - 1, null]);
        else if (last != null)
            output.push(last);
        if (i >= data_length)
            break;
        bucket_l += x_per_bucket;
    }
    return output;
}
